import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ArrowUpRight } from 'lucide-react';
import type { Prompt } from '../model/prompts';
import { riseSx } from './motion';

type Props = { title: string; prompts: Prompt[]; onPick: (prompt: string) => void };

export function PromptGroup({ title, prompts, onPick }: Props) {
  return (
    <Box component="section" aria-label={title} sx={{ mb: 1.5, ...riseSx }}>
      <Stack direction="row" sx={{ justifyContent: 'space-between', px: 1.25, py: 0.75 }}>
        <Typography variant="caption" component="h3" sx={{ color: 'text.secondary', fontWeight: 500 }}>{title}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>{prompts.length}</Typography>
      </Stack>
      <Stack component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {prompts.map((p) => (
          <li key={p.text}>
            <ButtonBase onClick={() => { onPick(p.text); }} sx={rowSx}>
              <Typography variant="body2" sx={{ flexGrow: 1, textAlign: 'left', fontSize: '0.8125rem' }}>{p.text}</Typography>
              <ArrowUpRight className="arrow" size={14} aria-hidden />
            </ButtonBase>
          </li>
        ))}
      </Stack>
    </Box>
  );
}

const rowSx = {
  width: '100%',
  alignItems: 'flex-start',
  gap: 1.5,
  px: 1.25,
  py: 0.875,
  borderRadius: 1,
  transition: 'background-color 120ms',
  '& .arrow': { flexShrink: 0, mt: 0.25, color: 'text.disabled', transition: 'transform 150ms, color 150ms' },
  '&:hover': { bgcolor: 'surface.subtle', '& .arrow': { color: 'primary.main', transform: 'translate(1px, -1px)' } },
} as const;
